export const PREVIOUS_PATH_KEY = 'previousPath';
export const DEBUG_MODE_DISABLED_KEY = 'debug-mode-disabled';
export const DEBUG_SECTIONS_SELECTOR_KEY = 'debug-sections-selector';
export const DEBUG_SETTINGS_STORE_KEY = 'debug-settings-store';
export const INSPECTOR_STORE_KEY = 'inspector-store';
